// Theme toggle functionality
(function() {
    const html = document.documentElement;
    const themeToggle = document.getElementById('theme-toggle');
    // Load saved theme preference, else follow the OS preference.
    // (The template sets data-theme before first paint; this keeps both in sync.)
    const savedTheme = localStorage.getItem('theme');
    const currentTheme = savedTheme === 'dark' || savedTheme === 'light' ? savedTheme : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    html.setAttribute('data-theme', currentTheme);
    updateToggleButton(currentTheme);
    // Toggle theme on button click
    if (themeToggle) themeToggle.addEventListener('click', ()=>{
        const currentTheme = html.getAttribute('data-theme');
        const newTheme = currentTheme === 'light' ? 'dark' : 'light';
        html.setAttribute('data-theme', newTheme);
        localStorage.setItem('theme', newTheme);
        updateToggleButton(newTheme);
    });
    /**
   * Update the button's accessible label; the moon/sun icons swap via CSS
   * on [data-theme], so nothing needs to change in the DOM.
   */ function updateToggleButton(theme) {
        if (themeToggle) themeToggle.setAttribute('aria-label', theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode');
    }
})();
// Blog sticky navbar: scroll shadow + mobile menu toggle
(function() {
    const topbar = document.getElementById('blog-topbar');
    if (!topbar) return;
    const toggle = document.getElementById('nav-toggle');
    const nav = document.getElementById('blog-nav');
    // Add a subtle shadow/border once the page is scrolled.
    const onScroll = ()=>{
        topbar.classList.toggle('is-scrolled', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    onScroll();
    if (!toggle || !nav) return;
    const closeMenu = ()=>{
        topbar.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
    };
    toggle.addEventListener('click', ()=>{
        const isOpen = topbar.classList.toggle('nav-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
    });
    // Close the menu when a link is chosen or focus/clicks leave the bar.
    nav.addEventListener('click', (e)=>{
        if (e.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') closeMenu();
    });
    document.addEventListener('click', (e)=>{
        if (!topbar.contains(e.target)) closeMenu();
    });
    // Blog index only: on mobile the search/tag controls live inside the
    // hamburger panel; on desktop they sit in the page above the feed.
    const controls = document.querySelector('.blog-controls');
    const blogIndex = document.querySelector('.blog-index');
    if (controls && blogIndex) {
        const mql = window.matchMedia('(max-width: 768px)');
        const placeControls = ()=>{
            if (mql.matches) nav.appendChild(controls);
            else {
                blogIndex.before(controls);
                closeMenu();
            }
        };
        mql.addEventListener('change', placeControls);
        placeControls();
    }
})();
// Blog index search + tag filtering
(function() {
    const entries = Array.from(document.querySelectorAll('.blog-entry'));
    if (!entries.length) return;
    const filter = document.querySelector('.tag-filter');
    const searchInput = document.getElementById('blog-search-input');
    const noResults = document.querySelector('.no-results');
    const countEl = document.getElementById('blog-count');
    const buttons = filter ? Array.from(filter.querySelectorAll('.tag-filter-btn[data-tag]')) : [];
    // Map each month divider to the entries that follow it so empty groups
    // can be hidden while filtering.
    const main = document.querySelector('.blog-index');
    const dividerGroups = new Map();
    if (main) {
        let currentDivider = null;
        for (const el of main.children){
            if (el.classList.contains('month-divider')) {
                currentDivider = el;
                dividerGroups.set(el, []);
            } else if (el.classList.contains('blog-entry') && currentDivider) dividerGroups.get(currentDivider).push(el);
        }
    }
    let activeTag = 'all';
    let query = '';
    function formatCount(n) {
        return `${n} ${n === 1 ? 'article' : 'articles'}`;
    }
    function apply() {
        let visible = 0;
        entries.forEach((entry)=>{
            const tags = (entry.dataset.tags || '').split('|').filter(Boolean);
            const matchesTag = activeTag === 'all' || tags.includes(activeTag);
            const matchesQuery = !query || (entry.dataset.search || '').includes(query);
            const show = matchesTag && matchesQuery;
            entry.hidden = !show;
            if (show) visible++;
        });
        dividerGroups.forEach((group, divider)=>{
            divider.hidden = !group.some((e)=>!e.hidden);
        });
        if (noResults) noResults.hidden = visible !== 0;
        if (countEl) countEl.textContent = formatCount(visible);
    }
    if (filter) filter.addEventListener('click', (e)=>{
        const btn = e.target.closest('.tag-filter-btn');
        if (!btn || !btn.dataset.tag) return;
        activeTag = btn.dataset.tag;
        buttons.forEach((b)=>{
            const isActive = b === btn;
            b.classList.toggle('is-active', isActive);
            b.setAttribute('aria-pressed', String(isActive));
        });
        apply();
    });
    if (searchInput) searchInput.addEventListener('input', ()=>{
        query = searchInput.value.trim().toLowerCase();
        apply();
    });
})();
// Article reading progress bar
(function() {
    // Only present on individual article pages (which render a .content block).
    if (!document.querySelector('article .content')) return;
    const bar = document.createElement('div');
    bar.className = 'reading-progress';
    bar.setAttribute('aria-hidden', 'true');
    const fill = document.createElement('span');
    fill.className = 'reading-progress-fill';
    bar.appendChild(fill);
    document.body.appendChild(bar);
    function update() {
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const pct = docHeight > 0 ? window.scrollY / docHeight * 100 : 0;
        fill.style.width = `${Math.min(100, Math.max(0, pct))}%`;
    }
    window.addEventListener('scroll', update, {
        passive: true
    });
    window.addEventListener('resize', update);
    update();
})();
// Blog index: collapse the tag bar to the first 10 tags behind a "+N more"
// toggle, and activate a filter when the URL has a #tag=<key> deep link.
(function() {
    const filter = document.querySelector('.tag-filter');
    if (!filter) return;
    const btns = Array.from(filter.querySelectorAll('.tag-filter-btn:not([data-tag="all"])'));
    const MAX_VISIBLE = 10;
    const extra = btns.slice(MAX_VISIBLE);
    const more = document.createElement('button');
    if (extra.length) {
        more.type = 'button';
        more.className = 'tag-filter-btn tag-filter-more';
        more.setAttribute('aria-expanded', 'false');
        more.textContent = `+${extra.length} more`;
        extra.forEach((b)=>b.classList.add('is-collapsed'));
        filter.appendChild(more);
        more.addEventListener('click', ()=>{
            const open = more.getAttribute('aria-expanded') === 'true';
            more.setAttribute('aria-expanded', String(!open));
            extra.forEach((b)=>b.classList.toggle('is-collapsed', open));
            more.textContent = open ? `+${extra.length} more` : 'Show fewer';
        });
    }
    const m = location.hash.match(/^#tag=(.+)$/);
    if (m) {
        const target = filter.querySelector(`[data-tag="${CSS.escape(decodeURIComponent(m[1]))}"]`);
        if (target) {
            if (target.classList.contains('is-collapsed') && more.isConnected) more.click();
            target.click();
            target.scrollIntoView({
                block: 'nearest'
            });
            // On mobile the filters live inside the hamburger panel — open it
            // so the active filter is actually visible.
            const topbar = document.getElementById('blog-topbar');
            const toggle = document.getElementById('nav-toggle');
            if (topbar && toggle && window.matchMedia('(max-width: 768px)').matches) {
                topbar.classList.add('nav-open');
                toggle.setAttribute('aria-expanded', 'true');
            }
        }
    }
})();
// Article pages: heading anchors, "On this page" TOC with scrollspy,
// and copy buttons on code blocks.
(function() {
    const content = document.querySelector('article .content');
    if (!content) return;
    const heads = Array.from(content.querySelectorAll('h2, h3'));
    heads.forEach((h, i)=>{
        h.dataset.title = h.textContent;
        if (!h.id) h.id = h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || `section-${i}`;
        const anchor = document.createElement('a');
        anchor.className = 'heading-anchor';
        anchor.href = `#${h.id}`;
        anchor.textContent = '#';
        anchor.setAttribute('aria-label', `Link to section: ${h.textContent}`);
        h.appendChild(anchor);
    });
    const list = document.getElementById('toc-list');
    if (list) {
        const h2s = heads.filter((h)=>h.tagName === 'H2');
        if (h2s.length < 3) {
            const rail = document.querySelector('.toc-rail');
            if (rail) rail.remove();
        } else {
            h2s.forEach((h)=>{
                const li = document.createElement('li');
                const a = document.createElement('a');
                a.href = `#${h.id}`;
                a.textContent = h.dataset.title;
                li.appendChild(a);
                list.appendChild(li);
            });
            const links = Array.from(list.querySelectorAll('a'));
            const obs = new IntersectionObserver((entries)=>{
                entries.forEach((e)=>{
                    if (e.isIntersecting) links.forEach((l)=>l.classList.toggle('is-active', l.getAttribute('href') === `#${e.target.id}`));
                });
            }, {
                rootMargin: '-10% 0px -75% 0px'
            });
            h2s.forEach((h)=>obs.observe(h));
        }
    }
    content.querySelectorAll('pre').forEach((pre)=>{
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'copy-btn';
        btn.textContent = 'Copy';
        btn.addEventListener('click', async ()=>{
            try {
                await navigator.clipboard.writeText(pre.innerText);
                btn.textContent = 'Copied';
                btn.classList.add('is-copied');
                setTimeout(()=>{
                    btn.textContent = 'Copy';
                    btn.classList.remove('is-copied');
                }, 1600);
            } catch (e) {
                btn.textContent = 'Error';
            }
        });
        pre.appendChild(btn);
    });
})();

//# sourceMappingURL=blog.a01e260b.js.map
